module.exports = "/images/RN.png?b2bf757c6eeb6bc638cf211bfe77be7b";